import {combineReducers} from 'redux';
import {getUserCreateInvoceReducer} from './getUsersReducer'

import {getUserCreateInvoceFilesReducer} from './getUserFiles'
import {addExpenseReducer} from './addExpenseRed'
import { getServicesTypeReducer } from "./getServiceType";
import {addServicesTypeReducer} from './addServiceType'

const reducer = combineReducers({
  addServicesTypeReducer,getServicesTypeReducer,getUserCreateInvoceReducer,getUserCreateInvoceFilesReducer,addExpenseReducer 
    });
    
    export default reducer;
